/**
 * The work-specific title shown under the catalog name (#3655), or null when
 * there is none. Rows created before #3655 stored the catalog name as the
 * title; a title that only repeats the name is no title.
 */
export function distinctServiceTitle(
  name: string | null | undefined,
  title: string | null | undefined,
): string | null {
  const trimmed = title?.trim();
  return trimmed && trimmed !== name ? trimmed : null;
}
